export { ContactInfo } from './contact-info'
